import Box from '@mui/material/Box'
import React, { FC, ReactElement } from 'react'
import ButtonComponent from './ButtonComponent'
import Preloader from './Preloader'
import { ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  text: string | ReactElement
  loading?: boolean
  disableButton?: boolean
  position: 'left' | 'right'
  onClick?: () => void
}

const PreloaderButton: FC<Props> = (props) => {

  const showPreloader = () => {
    return props.loading
      ? <Preloader width='auto' minHeight='0' size={24} />
      : <Box sx={{ width: 24, height: 24 }}/>
  }

  return (
    <Box display='flex' justifyContent={props.position === 'right' ? 'flex-end' : 'flex-start'} alignItems='center'>
      {props.position === 'right' && showPreloader()}
      <Box sx={{ ml: props.position === 'right' ? 2 : 0, mr: props.position === 'left' ? 2 : 0 }}>
        <ButtonComponent
          disabled={props.disableButton ? props.disableButton : props.loading}
          onClick={() => props.onClick && props.onClick()}
          variant='contained'
          text={props.text}
        />
      </Box>
      {props.position === 'left' && showPreloader()}
    </Box>
  )
}

export default PreloaderButton
